import { preventSpamOnClickCreateEntityButton } from "../data_pages/prevent_spam";
import Alpine from "alpinejs";
import { fetch } from "../framework/api.js";

let confirmedCompanyIds = {};
let confirmedCompanyNames = {};
let rqthSections = {};
let legalRepresentativeSection = null;
let statusSections = {};
let statusEnabledInputs = {};
let birthdateInputs = {};
let handicapedInputs = {};
let statusInputs = {};

document.addEventListener("DOMContentLoaded", function () {
  const traineeForm = document.querySelector(".js-trainee-form");

  if (traineeForm) {
    const formIds = JSON.parse(traineeForm.dataset.formIds);
    let initialFormId = traineeForm.dataset.selectedFormId || formIds[0];

    legalRepresentativeSection = traineeForm.querySelector(".js-legal-representative-section");

    formIds.forEach((formId) => {
      initBirthdate(traineeForm, formId, initialFormId);
      initHandicaped(traineeForm, formId);
      initStatus(traineeForm, formId, initialFormId);

      initTraineeAutocomplete(traineeForm, formId);
      initCompanyAutocomplete(traineeForm, formId);
    });

    traineeForm.addEventListener("changeMergerSelectionMode", (event) => {
      const formId = event.detail.formId;
      const otherFormKeys = formIds.filter((key) => key !== formId);

      switch (event.detail.inputName) {
        case "birthdate": {
          commitBirthdate(birthdateInputs[formId]?.value);
          break;
        }
        case "status": {
          const sections = Object.values(statusSections[formId]).flat();
          const otherSections = otherFormKeys.flatMap((key) => Object.values(statusSections[key]).flat());
          sections.forEach((section) => enableInputs(section));
          otherSections.forEach((section) => disableInputs(section));

          onStatusChanged(statusInputs[formId]?.value, formId);
          break;
        }
        case "handicaped": {
          const otherRqthSections = otherFormKeys.flatMap((key) => rqthSections[key]);

          enableInputs(rqthSections[formId]);
          otherRqthSections.forEach((section) => disableInputs(section));
          break;
        }
        case "all": {
          commitBirthdate(birthdateInputs[formId]?.value);
          onStatusChanged(statusInputs[formId]?.value, formId);
          break;
        }
      }
    });

    traineeForm.querySelectorAll(".js-create-trainee")?.forEach((element) => {
      element.addEventListener("click", (event) => {
        const birthdate = traineeForm.querySelector("[name='trainee[birthdate]']:not(:disabled)")?.value;
        commitBirthdate(birthdate);
        preventSpamOnClickCreateEntityButton(event);
      });
    });
  }
});

function initBirthdate(form, formId, initialFormId) {
  const birthdateInput = findInForm(form, formId, "[name='trainee[birthdate]']");
  birthdateInputs[formId] = birthdateInput;

  if (!legalRepresentativeSection || !birthdateInput) return;

  if (formId == initialFormId && !isMinor(birthdateInput.value)) legalRepresentativeSection.classList.add("has-hidden");
  birthdateInput.addEventListener("blur", (event) => commitBirthdate(event.target.value));
}

function commitBirthdate(birthdate) {
  if (!legalRepresentativeSection) return;

  if (!isMinor(birthdate)) {
    clearInputs(legalRepresentativeSection);
    legalRepresentativeSection.classList.add("has-hidden");
  } else {
    legalRepresentativeSection.classList.remove("has-hidden");
  }
}

function initHandicaped(form, formId) {
  const rqthSection = findInForm(form, formId, ".js-rqth-alternative");
  const handicapedInput = findInForm(form, formId, "input[type='checkbox'][name='trainee[handicaped]']");

  rqthSections[formId] = rqthSection;
  handicapedInputs[formId] = handicapedInput;

  if (!rqthSection || !handicapedInput) return;

  if (handicapedInput.checked) rqthSection.classList.add("has-hidden");
  handicapedInput.addEventListener("change", (event) => onToggleHandicaped(event.target.checked, formId));
}

function onToggleHandicaped(handicaped, formId) {
  const rqthSection = rqthSections[formId];
  if (!rqthSection) return;

  if (handicaped) {
    clearInputs(rqthSection);
    rqthSection.classList.add("has-hidden");
  } else {
    rqthSection.classList.remove("has-hidden");
  }
}

function initStatus(form, formId) {
  const sections = {
    employee: [...findAllInForm(form, formId, ".js-employee-status-section")],
    unemployed: [...findAllInForm(form, formId, ".js-unemployed-status-section")],
    apprentice: [...findAllInForm(form, formId, ".js-apprentice-status-section")],
    independant: [...findAllInForm(form, formId, ".js-independant-status-section")],
    individual: [...findAllInForm(form, formId, ".js-individual-status-section")],
  };
  const enabledInputs = {
    employee: [...findAllInForm(form, formId, ".js-employee-status-enabled")],
    unemployed: [...findAllInForm(form, formId, ".js-unemployed-status-enabled")],
    apprentice: [...findAllInForm(form, formId, ".js-apprentice-status-enabled")],
    independant: [...findAllInForm(form, formId, ".js-independant-status-enabled")],
    individual: [...findAllInForm(form, formId, ".js-individual-status-enabled")],
  };

  statusSections[formId] = sections;
  statusEnabledInputs[formId] = enabledInputs;

  statusInputs[formId] = findInForm(form, formId, "select[name='trainee[status]']");

  if (!statusInputs[formId]) return;

  onStatusChanged(statusInputs[formId].value, formId);
  statusInputs[formId].addEventListener("change", (event) => onStatusChanged(event.target.value, formId));
}

function onStatusChanged(status, formId) {
  if (!status) return;

  const statusSection = statusSections[formId][status];

  const statusEnabledInput = statusEnabledInputs[formId][status];

  const otherSectionsKeys = Object.keys(statusSections[formId]).filter((key) => key !== status);
  const otherStatusSections = otherSectionsKeys.flatMap((key) => statusSections[formId][key]);
  const otherStatusEnabledInputs = otherSectionsKeys.flatMap((key) => statusEnabledInputs[formId][key]);

  otherStatusEnabledInputs.forEach((input) => (input.disabled = true));
  otherStatusSections.forEach((section) => section.classList.add("has-hidden"));
  statusEnabledInput.forEach((input) => (input.disabled = false));
  statusSection.forEach((section) => section.classList.remove("has-hidden"));
}

function initTraineeAutocomplete(form, formId) {
  findInForm(form, formId, ".firstname-input")?.addEventListener("autocomplete", (e) => onTraineeChanged(e, form, formId));
  findInForm(form, formId, ".lastname-input")?.addEventListener("autocomplete", (e) => onTraineeChanged(e, form, formId));
  findInForm(form, formId, ".email-input")?.addEventListener("autocomplete", (e) => onTraineeChanged(e, form, formId));
}

function onTraineeChanged({ detail: trainee }, form, formId) {
  if (!trainee) {
    return;
  }

  autocompleteCustomFields(trainee, form, formId);
  cleanCompanyAndPosition(trainee);

  // Set the inputs
  [...findAllInForm(form, formId, "[name^='trainee[']")].forEach((input) => {
    let propertyName = unobfuscate(input.getAttribute("name").split("[").pop().replace("]", ""));
    if (Object.prototype.hasOwnProperty.call(trainee, propertyName)) {
      if (input.type === "checkbox") {
        input.checked = trainee[propertyName];
      } else {
        input.value = trainee[propertyName];
        $(input).typeahead("val", trainee[propertyName]);
      }
    }
  });

  onStatusChanged(statusInputs[formId]?.value, formId);
  onToggleHandicaped(handicapedInputs[formId]?.checked, formId);
  commitBirthdate(birthdateInputs[formId]?.value);

  // Updates the trainee logo preview inside the single file input component, which is only
  // rendered when the registration config asks for a logo
  const logoHost = findInForm(form, formId, ".single-file-input");
  if (trainee.logo && logoHost) {
    Alpine.$data(logoHost).file = trainee.logo;
  }

  // The company fields are submitted under `position[...]`, so the loop above never reaches them.
  if ("company_id" in trainee) setTraineeFormValue(form, formId, "[name='position[company_id]']", trainee.company_id);
  if ("company_name" in trainee) setTraineeFormValue(form, formId, "[name='position[company_name]']", trainee.company_name);
  if ("company_position" in trainee) setTraineeFormValue(form, formId, "[name='position[position]']", trainee.company_position);
}

function initCompanyAutocomplete(form, formId) {
  const companyIdInput = findInForm(form, formId, "[name='position[company_id]']");
  const companyNameInput = findInForm(form, formId, "[name='position[company_name]']");

  if (!companyIdInput || !companyNameInput) return;

  companyNameInput.addEventListener("autocomplete", (e) => onCompanyChanged(e, form, formId));

  if (companyIdInput.value) {
    confirmedCompanyIds[formId] = companyIdInput.value;
    confirmedCompanyNames[formId] = companyNameInput?.value || null;
  }

  checkIfCompanySelected(form, formId);

  // Force autocomplete.js to check if the value is valid
  setTimeout(function () {
    companyNameInput?.dispatchEvent(new Event("keyup"));
  }, 2000);
}

function onCompanyChanged({ detail: company }, form, formId) {
  const helper = findInForm(form, formId, ".js-trainee-unknown-company-helper");

  if (company) {
    confirmedCompanyIds[formId] = company.id;
    confirmedCompanyNames[formId] = company.name;
    setTraineeFormValue(form, formId, "[name='position[company_id]']", company.id);
    setTraineeFormValue(form, formId, "[name='position[company_name]']", company.name);
    helper.classList.add("has-hidden");
    updateManagerContactOptions(company.id, form, formId);
  } else {
    const inputCompanyName = findInForm(form, formId, "[name='position[company_name]']")?.value;
    // Autocomplete fires null on blur even without text change; preserve selection when name unchanged.
    if (confirmedCompanyIds[formId] && sameCompanyName(confirmedCompanyNames[formId], inputCompanyName)) {
      helper.classList.add("has-hidden");
      updateManagerContactOptions(confirmedCompanyIds[formId], form, formId);
      return;
    }

    confirmedCompanyIds[formId] = null;
    confirmedCompanyNames[formId] = null;
    setTraineeFormValue(form, formId, "[name='position[company_id]']", inputCompanyName ? -1 : null);
    if (inputCompanyName) helper.classList.remove("has-hidden");
    else helper.classList.add("has-hidden");
    updateManagerContactOptions(null, form, formId);
  }
}

// Resets every field inside a container so hidden CFA sections are not submitted with stale values.
// The container is absent whenever the CFA fields are not rendered at all.
function clearInputs(container) {
  if (!container) return;

  container.querySelectorAll("input, select, textarea").forEach((field) => {
    if (field.type === "checkbox" || field.type === "radio") field.checked = false;
    else field.value = "";
  });
}

function disableInputs(container) {
  if (!container) return;

  container.querySelectorAll("input, select, textarea").forEach((field) => (field.disabled = true));
}

function enableInputs(container) {
  if (!container) return;

  container.querySelectorAll("input, select, textarea").forEach((field) => (field.disabled = false));
}

// Unknown or invalid birthdate means we cannot confirm the trainee is a minor.
// Parse by component (not new Date) to avoid the UTC-vs-local shift and the Feb 29 overflow.
function isMinor(birthdateValue) {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(birthdateValue || "");
  if (!match) return false;
  const [, year, month, day] = match.map(Number);
  const now = new Date();
  let age = now.getFullYear() - year;
  const monthNow = now.getMonth() + 1;
  if (monthNow < month || (monthNow === month && now.getDate() < day)) age--;
  return age < 18;
}

function checkIfCompanySelected(form, formId) {
  // Set the Company from query parameters
  let company_id = getQueryParameter("company_id");
  let company_name = getQueryParameter("company_name");

  if (!company_id || !company_name) return;
  confirmedCompanyIds[formId] = company_id;
  confirmedCompanyNames[formId] = company_name;
  setTraineeFormValue(form, formId, "[name='position[company_id]']", company_id);
  setTraineeFormValue(form, formId, "[name='position[company_name]']", company_name);
}

function sameCompanyName(a, b) {
  return (a || "").trim().toLowerCase() === (b || "").trim().toLowerCase();
}

function updateManagerContactOptions(companyId, form, formId) {
  const selects = [
    findInForm(form, formId, "select[name='position[manager_contact_id]']"),
    findInForm(form, formId, "select[name='position[second_manager_contact_id]']"),
  ].filter(Boolean);

  // The public registration forms don't render the manager selects — bail out silently if absent
  if (selects.length === 0) return;

  if (!companyId) {
    selects.forEach(resetManagerContactOptions);
    return;
  }

  fetch(`/ajax/companies/${companyId}/manager_contacts`)
    .then((res) => res.json())
    .then(({ data }) => {
      selects.forEach((select) => {
        // Capture before replaceChildren wipes the DOM — value is reliable at this point
        const currentValue = select.value;
        const prompt = select.querySelector("option[value='']");
        select.replaceChildren();

        if (prompt) select.appendChild(prompt);

        data.forEach(({ id, name }) => {
          const option = document.createElement("option");
          option.value = id;
          option.textContent = name;
          select.appendChild(option);
        });

        // Keep the previous selection only if it still exists in the new company's contacts
        select.value = data.some((c) => String(c.id) === currentValue) ? currentValue : "";
      });
    })
    .catch(() => {
      selects.forEach(resetManagerContactOptions);
    });
}

function resetManagerContactOptions(select) {
  const prompt = select.querySelector("option[value='']");
  select.replaceChildren();
  if (prompt) select.appendChild(prompt);
  select.value = "";
}

function autocompleteCustomFields(resource, form, formId) {
  if (!resource.custom_fields) {
    return;
  }
  resource.custom_fields.forEach((customField) => {
    setTraineeFormValue(form, formId, `[data-custom-field-id='${customField.custom_form_field.id}']`, customField.data.value);
  });
}

function setTraineeFormValue(form, formId, selector, value) {
  const input = findInForm(form, formId, selector);
  if (!input) return;

  if (input.type === "checkbox" || input.type === "radio") input.checked = Boolean(value);
  else input.value = value ?? "";
}

function findAllInForm(form, formId, selector) {
  return form.querySelectorAll(`.js-entity-form-inputs-parent-${formId} ${selector}`);
}

function findInForm(form, formId, selector) {
  return form.querySelector(`.js-entity-form-inputs-parent-${formId} ${selector}`);
}

//------------------------------------------------------------------------------
// Utilities
//------------------------------------------------------------------------------

function cleanCompanyAndPosition(trainee) {
  if (trainee.company_positions !== undefined && trainee.company_positions.length > 0) {
    if (trainee.company_positions[0].company !== null) {
      let company = trainee.company_positions[0].company;
      trainee.company_name = company.name;
      trainee.company_id = company.id;
    }

    trainee.company_position = trainee.company_positions[0].position;
  }

  delete trainee.company_positions;
}

function unobfuscate(prop) {
  if (prop === "emantsrif") {
    return "firstname";
  }
  if (prop === "emantsal") {
    return "lastname";
  }
  if (prop === "liame") {
    return "email";
  }
  return prop;
}
